module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', [_c('div', {
    staticClass: "tabContainer"
  }, [_c('div', {
    ref: "vizContainer",
    style: ({
      'height': this.reportHeight + 'px',
      'min-height': this.reportMinHeight + 'px'
    }),
    attrs: {
      "id": "vizContainer"
    }
  }, [_c('iframe', {
    ref: "edit_iframe",
    staticStyle: {
      "padding": "0px",
      "border": "none",
      "margin": "0px",
      "height": "800px",
      "width": "100%"
    },
    attrs: {
      "src": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "loginContainer",
    staticStyle: {
      "padding": "0px",
      "border": "none",
      "margin": "0px",
      "width": "0px",
      "height": "0px"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e3dca8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TableauEdit.vue
// module id = 483
// module chunks = 2